import {
  GET_DIFFICULTIES_START,
  GET_DIFFICULTIES_SUCCESS,
  GET_DIFFICULTIES_ERROR,
  CREATE_DIFFICULTIES_START,
  CREATE_DIFFICULTIES_SUCCESS,
  CREATE_DIFFICULTIES_ERROR,
  EDIT_DIFFICULTY,
  EDIT_DIFFICULTY_START,
  EDIT_DIFFICULTY_SUCCESS,
  EDIT_DIFFICULTY_ERROR,
  DELETE_DIFFICULTY_START,
  DELETE_DIFFICULTY_SUCCESS,
  DELETE_DIFFICULTY_ERROR,
} from '../actions/difficulties/difficulties.actiontype';

export default function(state = { list: [] }, action) {
  switch (action.type) {
    case GET_DIFFICULTIES_START:
      return {
        ...state,
        isFetching: true,
      };
    case GET_DIFFICULTIES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        list: action.payload,
      };
    case GET_DIFFICULTIES_ERROR:
      return {
        ...state,
        isFetching: false,
      };
    case CREATE_DIFFICULTIES_START:
      return {
        ...state,
        isCreating: true,
      };
    case CREATE_DIFFICULTIES_SUCCESS:
      return {
        ...state,
        isCreating: false,
        list: [...state.list, action.payload],
      };
    case CREATE_DIFFICULTIES_ERROR:
      return {
        ...state,
        isCreating: false,
      };
    case EDIT_DIFFICULTY:
      return {
        ...state,
        difficultyToBeEdit: action.payload,
      };
    case EDIT_DIFFICULTY_START:
      return {
        ...state,
        isCreating: true,
      };
    case EDIT_DIFFICULTY_SUCCESS:
      return {
        ...state,
        isCreating: false,
        list: state.list.map(difficulty => {
          if (difficulty.id === action.payload.id) {
            return action.payload;
          }
          return difficulty;
        }),
      };
    case EDIT_DIFFICULTY_ERROR:
      return {
        ...state,
        isCreating: false,
      };
    case DELETE_DIFFICULTY_START:
      return {
        ...state,
        isDeleting: true,
      };
    case DELETE_DIFFICULTY_SUCCESS:
      const newList = state.list.filter(difficulty => difficulty.id !== action.payload.id);
      return {
        ...state,
        isDeleting: false,
        list: newList,
      };
    case DELETE_DIFFICULTY_ERROR:
      return {
        ...state,
        isDeleting: false,
      };
    default:
      return state;
  }
}
